import React from "react";
var __jsx = React.createElement;
import Image from "next/image";
import { useTranslation } from "react-i18next";
import { Skeleton } from "@mantine/core";

/** Loading placeholder shown while the action centre suggestion is being fetched. */
export function ActionCentreSkeleton() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "border-t border-sds-base-default"
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-3"
  }, /*#__PURE__*/React.createElement(Image, {
    src: "/assets/icons/aira-logo.svg",
    alt: "",
    width: 20,
    height: 20,
    className: "h-5 w-5 flex-shrink-0"
  }), /*#__PURE__*/React.createElement("span", {
    className: "text-style-body-base-strong text-sds-base-default"
  }, t("label.action_centre", {
    defaultValue: "Action centre"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "border-t border-sds-base-default"
  }), /*#__PURE__*/React.createElement(Skeleton, {
    height: 14,
    width: "65%",
    radius: "sm"
  }), /*#__PURE__*/React.createElement("div", {
    className: "rounded-sds-300 border border-sds-base-default bg-sds-base-default p-4 flex flex-col gap-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-3"
  }, /*#__PURE__*/React.createElement(Skeleton, {
    circle: true,
    height: 28,
    width: 28
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-1 flex-col gap-2"
  }, /*#__PURE__*/React.createElement(Skeleton, {
    height: 12,
    width: "35%",
    radius: "sm"
  }), /*#__PURE__*/React.createElement(Skeleton, {
    height: 10,
    width: "55%",
    radius: "sm"
  }))), /*#__PURE__*/React.createElement(Skeleton, {
    height: 72,
    radius: "md"
  }), /*#__PURE__*/React.createElement(Skeleton, {
    height: 72,
    radius: "md"
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-between"
  }, /*#__PURE__*/React.createElement(Skeleton, {
    height: 36,
    width: 150,
    radius: "sm"
  }), /*#__PURE__*/React.createElement(Skeleton, {
    height: 18,
    width: 160,
    radius: "sm"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "rounded-sds-300 border border-sds-base-default bg-sds-base-default p-4 flex flex-col gap-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-3"
  }, /*#__PURE__*/React.createElement(Skeleton, {
    circle: true,
    height: 28,
    width: 28
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-1 flex-col gap-2"
  }, /*#__PURE__*/React.createElement(Skeleton, {
    height: 12,
    width: "25%",
    radius: "sm"
  }), /*#__PURE__*/React.createElement(Skeleton, {
    height: 10,
    width: "45%",
    radius: "sm"
  }))), /*#__PURE__*/React.createElement(Skeleton, {
    height: 48,
    radius: "md"
  }))));
}